import { render, staticRenderFns } from "./ChatBoxReply.vue?vue&type=template&id=232ee843&scoped=true&"
import script from "./ChatBoxReply.vue?vue&type=script&lang=js&"
export * from "./ChatBoxReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxReply.vue?vue&type=style&index=0&id=232ee843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ee843",
  null
  
)

export default component.exports